import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doLoginRequest } from "../state/actions";
import { helmetRequest } from "../../app/state/actions";
import LoginForm from "../components/loginForm";
import Header from "../components/header";
import "./login.scss";
import { Toast } from "biologiatotal-ui";

class Login extends Component {
  constructor(props: Props) {
    super(props);

    this.onLogin = this.onLogin.bind(this);
  }

  componentDidMount() {
    const { helmetRequest, location } = this.props;
    const token = localStorage.getItem("bt:accessTokenAdmin");

    if (token) {
      return this.props.history.replace("/management");
    }

    if (location.pathname === "/management/login/recupera") {
      Toast.success(
        <div>
          <b>Sua senha foi alterada com sucesso!</b>
          <br />
          Utilize sua nova senha para acessar o Aprova Total!
        </div>
      );
    }

    helmetRequest({
      title: "Login",
      canonical: location.pathname
    });
  }

  onLogin(form) {
    return this.props.doLoginRequest(form).then(() => {
      return this.props.history.replace(`/management`);
    });
  }

  render() {
    const { data, history, account = {} } = this.props;
    const { ui = {} } = account;

    return (
      <Fragment>
        <div className="login">
          <Header />
          <LoginForm showLoginButton={true} onLogin={this.onLogin} isLogging={ui.isLogging} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.app,
    account: state.account
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      doLoginRequest,
      helmetRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));

Routered.displayName = "Login";

export default Routered;
